import { render, staticRenderFns } from "./Complete2.vue?vue&type=template&id=c2740ef6&"
import script from "./Complete2.vue?vue&type=script&lang=js&"
export * from "./Complete2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports